import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { Logo } from '../components/ui/Logo';
interface AuthLayoutProps {
  title: string;
  subtitle: string;
  children: ReactNode;
  footer?: ReactNode;
}
const BULLETS = ['CRM privado para tu empresa desde el primer minuto', 'Formularios y landings personalizables sin tocar código', 'Cada lead entra automáticamente en tu pipeline'];
export function AuthLayout({
  title,
  subtitle,
  children,
  footer
}: AuthLayoutProps) {
  return <div className="flex min-h-screen w-full bg-background" data-id="element-645" data-mp="zz7axwlt1h1i">
      <main className="flex w-full flex-col justify-center px-5 py-10 sm:px-10 lg:w-1/2" data-id="element-646" data-mp="m70vydue1g3n">
        <div className="mx-auto w-full max-w-md" data-id="element-647" data-mp="q7bcgkft3owr">
          <Link to="/" className="mb-10 inline-flex" aria-label="Ir al inicio" data-id="element-648" data-mp="q82vyww4pw6o">
            <Logo size={30} data-id="element-649" data-mp="c9cznjh4w0jd" />
          </Link>
          <h1 className="text-2xl font-semibold tracking-tight text-navy sm:text-3xl" data-id="element-650" data-mp="h752h8jbh72c">
            {title}
          </h1>
          <p className="mt-2 text-sm text-muted-foreground" data-id="element-651" data-mp="25j3vf1gerc7v">{subtitle}</p>
          <div className="mt-8" data-id="element-652" data-mp="20kiwr6gt10lj">{children}</div>
          {footer && <div className="mt-6 text-sm" data-id="element-653" data-mp="20k0rjkc5zc1h">{footer}</div>}
        </div>
      </main>

      <aside className="hidden w-1/2 flex-col justify-center border-l border-border bg-surface px-12 lg:flex" data-id="element-654" data-mp="2ej8sahnz6s7s">
        <div className="max-w-md" data-id="element-655" data-mp="29midryrtk4oh">
          <p className="text-xs font-semibold uppercase tracking-wider text-primary" data-id="element-656" data-mp="29je2yijumaou">
            Sistema AVA
          </p>
          <h2 className="mt-4 text-3xl font-semibold leading-tight text-navy" data-id="element-657" data-mp="1huausroucg6x">
            Atracción, Viralidad y Automatización en un solo lugar.
          </h2>
          <ul className="mt-8 space-y-4" data-id="element-658" data-mp="1vnipis87xrsu">
            {BULLETS.map(bullet => <li key={bullet} className="flex gap-3 text-sm text-muted-foreground" data-id="element-659" data-mp="1qt66gjanmihm">
                <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-primary/10" data-id="element-660" data-mp="133tx9jfbuafb">
                  <CheckIcon className="h-3 w-3 text-primary" aria-hidden="true" data-id="element-661" data-mp="y5s425o6suq4" />
                </span>
                {bullet}
              </li>)}
          </ul>
        </div>
      </aside>
    </div>;
}